



export const WashByIdPage = () => {
  return (
    <>
      <h1>Wash By ID Page</h1>
      <p>This page will display details for a specific wash based on its ID.</p>
    </>
  );
}